export const getBiomarkerLevelText = level => {
  if (!level || level.length == 0) return null;
  if (typeof level === "string") {
    if (level.toLowerCase() === "low") return "Low";
    if (["border-low", "borderline low"].includes(level.toLowerCase())) return "Border Low";
    if (level.toLowerCase() === "normal") return "Healthy";
    if (["border-high", "borderline high"].includes(level.toLowerCase())) return "Border High";
    if (level.toLowerCase() === "high") return "High";
    if (level.toLowerCase() === "positive") return "Positive";
    if (level.toLowerCase() === "negative") return "Negative";
  }

  if (Array.isArray(level)) {
    const levelCopy = [...level];
    const highestValue = levelCopy.sort((a, b) => {
      if (parseInt(b.y) < parseInt(a.y)) return -1;
      if (parseInt(b.y) > parseInt(a.y)) return 1;
      return 0;
    })[0].x;

    return getBiomarkerLevelText(highestValue);
  }

  return "Default";
};
